import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import {
	TQC2100_R01DetailDto,
	TQC2100_R01HeaderDto,
	TQC2100_R01InspectMasterDto,
} from "./Dto_TQC2100_R01";
import { TQC2100_R01Filter } from "./Store_TQC2100_R01";

/** 마스터 시편 측정등록 화면에서 사용하는 백엔드 API 모음 */
const baseUrl = `${config.apiUrl}/TQC2100_R01`;

/** 화면 검색조건을 조회 API의 요청 파라미터로 변환한다. */
const getParams = (filter: Partial<TQC2100_R01Filter>) => ({
	compCd: filter.compCd || "",
	inspectDt: filter.inspectDt || "",
});

export const getTQC2100_R01List = (option: string, params: Partial<TQC2100_R01Filter>) =>
	getData<ResponseDto<TQC2100_R01HeaderDto[]>>(`${baseUrl}/${option}`, {
		params: getParams(params),
	});

export const getTQC2100_R01AllCount = (params: Partial<TQC2100_R01Filter>) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params: getParams(params) });

export const getTQC2100_R01DetailList = (inspectNo: string) =>
	getData<ResponseDto<TQC2100_R01DetailDto[]>>(`${baseUrl}/detail/${inspectNo}`);

export const getTQC2100_R01InspectList = () =>
	getData<ResponseDto<TQC2100_R01InspectMasterDto[]>>(`${baseUrl}/inspect`);

/** 신규 측정결과를 항목·일자 단위의 flat 목록으로 저장한다. */
export const postTQC2100_R01 = (data: TQC2100_R01DetailDto[]) =>
	postData<TQC2100_R01DetailDto[], ResponseDto<unknown>>(baseUrl, data);

export const patchTQC2100_R01 = (data: TQC2100_R01DetailDto[]) =>
	patchData<TQC2100_R01DetailDto[], ResponseDto<unknown>>(baseUrl, data);

export const deleteTQC2100_R01 = (inspectNo: string, itemNo: string) =>
	deleteData<ResponseDto<unknown>>(baseUrl, { params: { inspectNo, itemNo } });

export const downloadExcel_TQC2100_R01 = (inspectNo: string) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel`, { params: { inspectNo } });

/** PDF 응답을 브라우저 출력과 QZ 인쇄에서 사용할 Blob으로 변환한다. */
export const getPdfBlob_TQC2100_R01 = async (inspectNo: string): Promise<Blob> => {
	const response = await getData<Blob>(`${baseUrl}/print`, {
		params: { inspectNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};
